export default "__VITE_ASSET__24744118__"